<template>
      <BannerCarousel
        apiEndpoint="/realtime-stats/"
        :transformData="transformStats"
        :refetchOnLanguageChange="true"
        height="50px"
        backgroundColor="#fff005"
        textColor="#000000"
        itemMinWidth="300px"
        position="top"
        :zIndex="99"
        :speed="50"
    >
        <template #item="{ item }">
            <div class="text-center">
                <div style="font-weight:bold">{{ item.value }}</div>
                <span>{{ item.label }}</span>
            </div>
        </template>
    </BannerCarousel>
    <div class="prices-container">
        <v-container fluid>
            <v-row class="text-center align-center justify-center gap">
                <!-- 6-Month Subscription Card -->
                <v-col cols="12" xs="8" sm="8" md="5" lg="5">
                    <div class="text-h4 py-2 text-left font-weight-bold">
                        {{ $t("landingPage.subscriptionPrices") }}
                    </div>
                    <v-card class="hoverable price-card py-5" elevation="0">
                        <v-card-text class="text-h5 font-weight-bold">
                            {{ $t("register.6months") }}
                        </v-card-text>
                        <v-card-text class="text-subtitle-1 mt-n6">{{
                            $t("register.access")
                        }}</v-card-text>
                        <v-card-text class="text-h2 font-weight-bold">
                            84<br />EUR
                        </v-card-text>
                        <v-btn @click="navigateToRegister(6)" class="w-50">{{
                            $t("landingPage.register")
                        }}</v-btn>
                        <v-card-text
                            class="text-subtitle-1 text-red font-italic"
                            >{{ $t("register.bankPayment") }}</v-card-text
                        >
                    </v-card>
                </v-col>

                <!-- 12-Month Subscription Card -->
                <v-col cols="12" xs="8" sm="8" md="5" lg="5">
                    <div v-show="$vuetify.display.mdAndUp"
                        class="pb-0 text-right text-h4 py-2 font-weight-bold"
                    >
                    <TextLink class="w-100 justify-start pl-0" :link="{ href: '/', text: $t('landingPage.back') }"/>
                    </div>
                    <v-card class="hoverable price-card py-5" elevation="0">
                        <v-card-text class="text-h5 font-weight-bold">
                            {{ $t("register.12months") }}
                        </v-card-text>
                        <v-card-text class="text-subtitle-1 mt-n6">{{
                            $t("register.access")
                        }}</v-card-text>
                        <v-card-text class="text-h2 font-weight-bold">
                            168<br />EUR
                        </v-card-text>
                        <v-btn @click="navigateToRegister(12)" class="w-50">{{
                            $t("landingPage.register")
                        }}</v-btn>
                        <v-card-text
                            class="text-subtitle-1 text-red font-italic"
                            >{{ $t("register.bankPayment") }}</v-card-text
                        >
                        
                    </v-card>
                    <TextLink class="d-flex w-100 justify-start pt-2 pl-0" v-if="!$vuetify.display.mdAndUp" :link="{ href: '/', text: $t('landingPage.back') }"/>
                </v-col>
            </v-row>
        </v-container>
    </div>
    <BottomBanner />
</template>

<script>
import BannerCarousel from "@/components/BannerCarousel.vue";
import BottomBanner from "@/components/BottomBanner.vue";
import TextLink from "@/components/registration/TextLink.vue";

export default {
    name: "Prices",
    components: {
        BannerCarousel,
        BottomBanner,
        TextLink
    },
    methods: {
        /**
         * Navigates to the RegisterForm view with the selected subscription period.
         * @param {number} months - The number of months for the subscription plan.
         */
        navigateToRegister(months) {
            this.$router.push({
                name: "Register",
                query: { subscriptionMonths: months },
            });
        },
    },
};
</script>

<style scoped>
.prices-container {
    padding-top: 64px; /* height of StatsBanner */
    padding-bottom: 64px; /* height of BottomBanner */
}

.gap {
    gap: 80px;
}

.price-card {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}

.hidden {
    color: transparent;
}

.hoverable {
    transition: box-shadow 0.3s ease;
}
.hoverable:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

@media (max-width: 960px) {
    .gap {
        gap: 20px;
    }

    .hidden {
        display: none;
    }
}

@media (max-width: 600px) {
    .prices-container {
        padding-top: 64px; /* height of StatsBanner */
        padding-bottom: 96px; /* height of BottomBanner */
    }
}
</style>